export default function () {
  this.route("mod-market", { path: "/mods" });
  this.route("mod-market-show", { path: "/mods/:slug/:mod_id" });
}
